module.exports = __webpack_public_path__ + "photogrid.65d5dc5712f887d82c07.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/assets/img/photogrid.jpg
// module id = ../../../../../src/assets/img/photogrid.jpg
// module chunks = styles